import { Component, DestroyRef, ElementRef, inject, Input, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { NgIf, DatePipe } from '@angular/common';
import { MatSortModule, Sort } from '@angular/material/sort';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from '../../elements/pagination/pagination.component';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelInputModule, SearchCountryField } from 'ngx-intl-tel-input';
import { User, Tenant } from '../../models/users.model';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TenantAddComponent } from './tenant-add/tenant-add.component';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { debounceTime, distinctUntilChanged, filter, Subject, Subscription, switchMap, tap } from 'rxjs';
import { HttpServiceService } from '../../services/http-service.service';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { Select2, Select2Data } from 'ng-select2-component';
import { NgSelectModule } from '@ng-select/ng-select';
import { Offcanvas } from 'bootstrap';
import { LocalStorageService } from '../../services/local-storage.service';
import { USER_PERMISSIONS, APP_CONSTANTS } from '../../app.constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-tenants',
  imports: [NgIf, ReactiveFormsModule, NgbModule, MatSortModule, PaginationComponent, NgxIntlTelInputModule, RouterModule, TenantAddComponent, BreadcrumbComponent, Select2, NgSelectModule, DatePipe],
  providers: [provideNativeDateAdapter()],
  templateUrl: './tenants.component.html',
  styleUrl: './tenants.component.css'
})
export class TenantsComponent implements OnDestroy {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Tenant',
    breadcrumb_url: '/admin/tenants'
  }
  offcanvasExample: boolean = false;
  offcanvasSearch: boolean = false;
  searchForm!: FormGroup;
  SearchCountryField = SearchCountryField;
  today: Date = new Date();
  @ViewChild(TenantAddComponent) tenant!: TenantAddComponent;
  addTenantSubscription?: Subscription;
  private httpService = inject(HttpServiceService);
  disableClear: boolean = false;
  cities_list: Select2Data = [];
  states_list: Select2Data = [];
  propertiesList: any = [];
  lastSearchTerm: any;
  hasMore: boolean = true;
  private getAllOwnersSubscription?: Subscription;
  private deleteUserSubscription?: Subscription;
  private getAllPropertiesSubscription?: Subscription;
  private getAllUsersSubscription?: Subscription;
  allUsers = [];
  orderData: Tenant[] = [];
  @ViewChild('advancedSearchPopup') searchcanvas!: ElementRef;
  private searchInstance: Offcanvas | null = null;
  private authService = inject(LocalStorageService);
  users: Select2Data = [];

  constructor(private fb: FormBuilder, private modalService: NgbModal, private alertService: NgxToastrService, private route: ActivatedRoute, private router : Router) {


    this.searchForm = this.fb.group({
      address: [''],
      contact_no: [''],
      search: [''],
      city: [''],
      state: [''],
      property: [null],
      status: [null],
      managed_by: ['']
    });

    //this.orderData = this.allUsers.slice();
  }

  offset_limit: number = 20;
  @Input() checkbox: boolean = false;

  active = 1;
  page: any = 1;
  totalRows: number = 5;
  totalPage: any = 0;
  allData: any = [];
  boxActive: Boolean = false;
  disableDate: boolean = true;
  searchInput$ = new Subject<string>();
  pageCount : number = 1;
  queryParamsSubsscription?: Subscription;
  isQueryParamsExists : boolean = false;
  sortBy : string = '';
  orderBy : string = '';
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    let cities = this.route.snapshot.data['data']?.["data"] ?? [];
    for (let city of cities) {
      this.cities_list.push(
        {
          value: city,
          label: city,
          data: { name: city }
        }
      )
    };
    let states = this.route.snapshot.data['states']?.["data"] ?? [];
    for (let state of states) {
      this.states_list.push({
        value: state,
        label: state,
        data: { name: state }
      })
    };
    // this.getAllTenants();
    this.getAllProperties();
    if(this.checkManagedByFilter) this.getAllUsers();

    this.searchForm.get('search')?.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(value => {
        if(!this.isQueryParamsExists) this.handleSearch(value);
      });

    this.searchInput$
      .pipe(
        debounceTime(300),
        takeUntilDestroyed(this.destroyRef),
        filter(term => {
          const skip = term === this.lastSearchTerm;
          return !skip;
        }),
        tap((term) => {
          this.page = 1;
          this.hasMore = true;
          this.lastSearchTerm = term;
        }),
        switchMap(term => {
          return this.httpService.getAllProperties(1, 20, "&name=" + term);
        }
        )
      )
      .subscribe(results => {
        let propertiesList = results.data["properties"] ?? [];
        if (propertiesList.length >= results.data["total"]) {
          this.hasMore = false;
        }
        this.propertiesList = [];
        for (let resp of propertiesList) {
          this.propertiesList.push(
            {
              value: resp.uid,
              label: resp.name,
              data: { name: resp.name }
            }
          )
        }
      });
    this.queryParamsSubsscription = this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      let resp = { ...data };
      if(resp.page){
         this.page = parseInt(resp.page);
         delete resp.page;
         const hasAnyValue = Object.values(resp).some(value => !!value);
         if(hasAnyValue){
          let formObj = { property: null, status : null, ...resp };
          this.isQueryParamsExists = true;
          queueMicrotask(() => {
           this.searchForm.patchValue(formObj);
          });
         }
         this.handleSearch('', "keepPage", resp);
      }else{
        this.isQueryParamsExists = false;
        this.page = 1;
        this.getAllTenants();
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const searchCanvasElement = this.searchcanvas?.nativeElement;
      if (searchCanvasElement) {
        Offcanvas.getOrCreateInstance(searchCanvasElement, {
          backdrop: 'static',
          keyboard: false,
        });
      }

    });
  }


  disableFutureDates = (date: Date | null): boolean => {
    return date ? date <= this.today : false;
  }

  toggleExample(data: any) {
    // this.offcanvasExample = !this.offcanvasExample;
    this.tenant.addPropertyEvent();
  }

  showHidePopup(){
    this.offcanvasSearch = !this.offcanvasSearch;
  }

  toggleSearch() {
    this.showHidePopup();
    if (this.searchInstance && this.offcanvasSearch) {
      this.searchInstance.show();
    }
  }

  openCenter(content: TemplateRef<any>) {
    this.modalService.open(content, { centered: true });
  }

  addTenant(tenant: any): void {
    if (tenant.valid) {
      let phone = tenant.get("phone")?.value, alternate_phone = tenant.get("alternate_phone")?.value ?? "";
      let obj = {
        ...tenant.value,
        dial_code: phone.dialCode,
        phone: phone.number?.replace(/[-\s]/g, ""),
        role_identifier: "tenant"
      }
      if (alternate_phone) {
        obj['alt_dial_code'] = alternate_phone.dialCode;
        obj['alternate_phone'] = alternate_phone.number?.replace(/[-\s]/g, "");
      }
      const cleanedUser = Object.fromEntries(
        Object.entries(obj).filter(([_, v]) => v !== null && v !== '')
      ) as unknown as User;
      this.addTenantSubscription = this.httpService.addUser(cleanedUser).subscribe({
        next: (resp) => {
          this.tenant.propertyClose();
          this.tenant.resetForm();
          this.getAllTenants();
          this.alertService.success(resp.message, "toast-top-right");
        }
      })

    } else {
      console.log('Form is invalid.');
    }
  }

  onSearch(): void {
    console.log(this.searchForm.value);
  }

  selectUser(userId: number) {
    //this.toggleExample('');
    //let userData = this.allData.data.find(( user: User ) => user.userId == userId);
    //this.userForm.patchValue(userData);
  }

  close() {
    //this.toggleExample();
    //this.userForm.reset();
  }

  searchClose() {
    this.searchForm.get('address')?.setValue('');
    this.searchForm.get('contact_no')?.setValue('');
    this.showHidePopup();
    if (this.searchInstance && this.offcanvasSearch) {
      this.searchInstance.show();
    }
  }



  getAllTenants(query: any = '') {
    this.getAllOwnersSubscription = this.httpService.getAllTenants(this.page, this.offset_limit, query).subscribe({
      next: (response) => {
        this.orderData = response['data']?.["users"];
        this.totalRows = this.offset_limit;
        this.allData = this.paginator(this.orderData, this.page, this.totalRows);
        this.totalPage = response.data.total;
        this.pageCount = response.data.pageCount;
      }
    })
  }

  handleSearch(value: any, keepPage: string = '', data : any = '') {
    const searchData = data ? data : this.searchForm.value;
    let query = '';
    for (let key in searchData) {
      if (searchData[key]) {
        query += `&${key}=${searchData[key]}`;
      }
    }
    if(this.sortBy) query += `&sortBy=${this.sortBy}&orderBy=${this.orderBy}`;
    if (!keepPage) this.page = 1;
    if (query || !value) {
      this.getAllTenants(query);
      this.disableClear = (value || query) ? true : false;
      if(this.offcanvasSearch){
        this.searchClose();
      }
    }
  }

  viewTenant(uid : string){
    let data = {
      ...this.searchForm.value,
      page : this.page
    }
    this.router.navigate(['/admin/owner-details/overview', 'tenant' , uid], {
      queryParams: data
    });
  }

  onScrollToEnd() {
    // Optional: For pagination / infinite scroll
    if (!this.hasMore) return;
    this.page += 1;
    this.offset_limit += 20;
    this.getAllPropertiesSubscription = this.httpService.getAllProperties(this.page, this.offset_limit).subscribe(response => {
      let resp = response.data["properties"] ?? [];
      if (this.propertiesList.length >= response.data["total"]) {
        this.hasMore = false;
      }
      let properties = [];
      for (let property of resp) {
        properties.push(
          {
            value: property.uid,
            label: property.name,
            data: { name: property.name }
          }
        )
      }
      this.propertiesList = [...this.propertiesList, ...properties];
    });
  }

  getAllProperties(query: any = '') {
    this.getAllPropertiesSubscription = this.httpService.getAllProperties(this.page, this.offset_limit).subscribe({
      next: (response) => {
        let propertiesList = response.data["properties"] ?? [];
        if (this.propertiesList.length >= response.data["total"]) {
          this.hasMore = false;
        }
        this.propertiesList = [];
        for (let resp of propertiesList) {
          this.propertiesList.push(
            {
              value: resp.uid,
              label: resp.name,
              data: { name: resp.name }
            }
          )
        }
      }
    })
  }

  resetSearchForm() {
    this.page = 1;
    this.sortBy = '';
    this.orderBy = '';
    this.searchForm.reset({ emitEvent: false });
    this.getAllTenants();
    this.disableClear = false;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
    });
    this.isQueryParamsExists = false;
  }

  deleteUser(uid: string){
    this.deleteUserSubscription = this.httpService.deleteUser(uid).subscribe({
      next : (response) =>{
        this.alertService.success(response.message, "toast-top-right");
        this.getAllTenants();
      }
    })
  }

   sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      return;
    }
    this.sortBy = sort.active;
    this.orderBy = sort.direction;
    this.handleSearch('', "keepPage");
  }

  pageChange(e: any) {
    if (e == this.page) return;
    this.page = e;
    this.handleSearch('', "keepPage");
  }

  paginator(items: any, current_page: any, per_page_items: any) {
    let page = current_page || 1,
      per_page = per_page_items || 10,
      offset = (page - 1) * per_page,

      paginatedItems = items,
      total_pages = Math.ceil(items.length / per_page);

    return {
      page: page,
      per_page: per_page,
      pre_page: page - 1 ? page - 1 : null,
      next_page: (total_pages > page) ? page + 1 : null,
      total: items.length,
      total_pages: total_pages,
      data: paginatedItems,
      startPage: offset + 1,
      endPage: page * per_page,
    };
  }

  checkUncheckAll() {
    if (this.boxActive) {
      this.boxActive = false;
    } else {
      this.boxActive = true;
    }
  }

  ngOnDestroy(): void {
    this.addTenantSubscription?.unsubscribe();
    this.deleteUserSubscription?.unsubscribe();
    this.getAllOwnersSubscription?.unsubscribe();
    this.getAllPropertiesSubscription?.unsubscribe();
    this.queryParamsSubsscription?.unsubscribe();
    this.getAllUsersSubscription?.unsubscribe();
  }

  get checkAddTenant() {
    return this.authService.checkPermission(USER_PERMISSIONS.TENANTS.TENANTS_ADD);
  }

  get checkEditTenant() {
    return this.authService.checkPermission(USER_PERMISSIONS.TENANTS.TENANTS_UPDATE);
  }

  get checkDeleteTenant() {
    return this.authService.checkPermission(USER_PERMISSIONS.TENANTS.TENANTS_DELETE);
  }

  get noPermission(){
    return USER_PERMISSIONS.ERROR_MSGS.PERMISSION_NOT_FOUND;
  }

  get checkManagedByFilter() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_MANAGED_BY_FILTER);
  }

  getAllUsers(){
    let query = `&role_identifier=${APP_CONSTANTS.USER_ROLES.PROPERTY_MANAGER}`;
    this.getAllUsersSubscription = this.httpService.getAllUsers(1, 200, query).subscribe({
      next : (response) => {
        for(let user of response.data.users){
            this.users.push(
              {
                value: user.uid,
                label: user.first_name + user.last_name,
                data: { name: user.first_name + user.last_name }
              }
            )
        }
      },
      error : (error) => {
        console.log(error);
      }
    })
  }

}


function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
